<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcasts')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Season</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <!-- <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            v-model="body"
          >
          </base-input> -->
          <b-form-group label="Description">
            <quill-editor
              v-model="body"
              :options="editorOption"
              class="quill-h200px my-2"
            />
          </b-form-group>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Category</p>
          <b-form-select
            v-model="category"
            placeholder="Select"
            class="w-full"
            required
          >
            <b-form-select-option
              v-for="item in getAllCategory.result"
              class="py-5"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
            </b-form-select-option>
          </b-form-select>
        </div>

        <!-- <small class="font-semibold">URL</small>
        <base-input
          alternative
          class="mb-3"
          name="Link"
          :rules="{
            required: true,
            regex:
              '(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?',
          }"
          placeholder="Enter URL"
          v-model="link"
        >
        </base-input>

        <small class="font-semibold">Upload Image</small>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />

        <div class="mb-2">
          <b-form-group label="Tags:" class="font-semibold">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="selectedtag" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedSeg" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedUsers" class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>

        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="onlyCorporatePodcast">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to add podcast in Corporate
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>

        <div class="mb-2">
          <b-form-checkbox
            id="checkbox-2"
            v-model="onlyRegistered"
            :disabled="onlyCorporatePodcast"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this podcast for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false || onlyCorporatePodcast"
          >
          </multiselect>
        </div> -->

        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      episodes: [],
      category: "",
      title: "",
      // image: null,
      // coverImage: null,
      body: "",
      // link: "",
      editorOption: {
        theme: "snow",
      },
      // selectedtag: null,
      // selectedUsers: null,
      // selectedSeg: null,
      // Ctags: [],
      // filter1: [],
      // filter2: [],
      // filter3: [],
      // imageErr: false,
      // msg: {},
      // selectedMembership: null,
      // membershipFilter: [],
      // onlyRegistered: false,

      // onlyCorporatePodcast: false,
      metaTitle: "",
      metaKeyword: "",
      metaDesc: "",
      metaCanonicalTag: "",
    };
  },
  computed: {
    // ...mapState("cms", {
    //   selectedpagecategory: "selectedpagecategory",
    //   filtertags: "filtertags",
    //   filters: "filters",
    // }),
    // ...mapState("subscribe", {
    //   get_all_membership: "get_all_membership",
    // }),
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      if (!this.body) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      let payload = {
        name: this.title,
        description: this.body,
        categoryId: this.category,

        metaTitle: this.metaTitle,
        metaCanonicalTag: this.metaCanonicalTag,
        metaDesc: this.metaDesc,
        metaKeyword: this.metaKeyword,
      };
      let loader = this.$loading();

      try {
        const blogdata = await this.$store.dispatch(
          "podcast/add_podcast",
          payload
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "podcasts" });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your podcast season has been successfully added to the website",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    // async onSubmit() {
    //   if (!this.onlyRegistered) {
    //     this.selectedMembership = null;
    //   }
    //   let FormData = require("form-data");
    //   let data = new FormData();
    //   this.Ctags.push(this.selectedtag, this.selectedSeg, this.selectedUsers);

    //   if (this.onlyCorporatePodcast) {
    //     const payload = new FormData();
    //     payload.append("title", this.title);
    //     payload.append("url", this.link);
    //     payload.append("bannerImage", this.coverImage);
    //     let result = await this.$store.dispatch("ffc/addPodcast", payload);
    //     console.log(result, "RESULTT");
    //     if (result.data) {
    //       data.append("onlyCorporatePodcast", true);
    //     }
    //   }
    //   data.append("type", "single");
    //   data.append("title", this.title);
    //   data.append("link", this.link);
    //   data.append("subTitle", "");
    //   data.append("media", this.coverImage);
    //   data.append("html", this.body);
    //   data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
    //   data.append("pageCategory", this.selectedpagecategory.id);

    //   data.append("metaKeyword", this.metaKeyword);
    //   data.append("metaCanonicalTag", this.metaCanonicalTag);
    //   data.append("metaDesc", this.metaDesc);
    //   data.append("metaTitle", this.metaTitle);

    //   data.append("memberships", JSON.stringify(this.selectedMembership));
    //   if (this.selectedMembership !== null) {
    //     data.append("onlySubscribed", true);
    //     data.append("onlyRegistered", true);
    //   } else {
    //     data.append("onlySubscribed", false);
    //     data.append("onlyRegistered", this.onlyRegistered);
    //   }

    //   let loader = this.$loading();

    //   if (!this.coverImage) {
    //     this.$swal.fire({
    //       text: "Please Select Image",
    //       confirmButtonText: "Okay",
    //       confirmButtonColor: "#830c81",
    //       showCancelButton: false,
    //     });
    //     loader.close();
    //     return;
    //   }

    //   try {
    //     const podcastdata = await this.$store.dispatch("cms/addPage", data);
    //     if (podcastdata.code == 200) {
    //       this.$router.push({ name: "podcasts" });
    //       this.$swal.fire({
    //         text: "Podcast successfully added",
    //         icon: "success",
    //         confirmButtonText: "Okay",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //     }
    //     loader.close();
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    //   this.onlyCorporatePodcast = false;
    // },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    // this.gettagsbycategory();
  },
  // watch: {
  //   membershipFilter() {
  //     if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
  //       this.selectedMembership = this.membershipFilter.filter((membership) => {
  //         let data = this.blog_data.memberships.find(
  //           (member) => member._id === membership._id
  //         );
  //         // return this.blog_data.memberships.includes(membership._id);
  //         return data;
  //       });
  //       // console.log(this.selectedMembership);
  //     }
  //   },
  // },
};
</script>
